'use client';

import { setBenefitContextHelper } from '@/lib/utils';
import {
    createContext,
    PropsWithChildren,
    useContext,
    useEffect,
    useState,
} from 'react';
import { StringParam, useQueryParams, withDefault } from 'use-query-params';

export type BenefitContextType = {
    benefitValue: string;
    setBenefitValue: (v: string) => void;
};

const BenefitContext = createContext<BenefitContextType | null>(null);

export function BenefitContextProvider({ children }: PropsWithChildren) {
    const [params] = useQueryParams(
        {
            line: withDefault(StringParam, ''),
        },
        {
            removeDefaultsFromUrl: true,
        }
    );
    const [benefit, setBenefit] = useState(params.line);

    useEffect(() => {
        if (params.line) {
            setBenefitContextHelper(params.line, setBenefit);
        }
    }, [params]);

    const value: BenefitContextType = {
        benefitValue: benefit,
        setBenefitValue: (v: string) => setBenefit(v),
    };

    return (
        <BenefitContext.Provider value={value}>
            {children}
        </BenefitContext.Provider>
    );
}

export function useBenefit() {
    const benefitContext = useContext(BenefitContext);
    if (!benefitContext) {
        throw new Error(
            'useBenefit must be used within a BenefitContextProvider'
        );
    }
    return benefitContext;
}
